import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Capacitor } from '@capacitor/core'
import { App, type Platform } from '@assembly/ui'
// Lato, as in Slack: bundled so every build (including the offline native apps) has it.
import '@fontsource/lato/400.css'
import '@fontsource/lato/400-italic.css'
import '@fontsource/lato/700.css'
import '@fontsource/lato/700-italic.css'
import '@fontsource/lato/900.css'
import '@assembly/ui/styles.css'

/** One bundle serves every target; pick the platform adapter at runtime. */
async function detectPlatform(): Promise<Platform> {
  if (window.assemblyDesktop) {
    const { createDesktopPlatform } = await import('./platforms/desktop')
    return createDesktopPlatform(window.assemblyDesktop)
  }
  if (Capacitor.isNativePlatform()) {
    const { createIosPlatform } = await import('./platforms/ios')
    return createIosPlatform()
  }
  const { createWebPlatform } = await import('./platforms/web')
  return await createWebPlatform()
}

detectPlatform().then((platform) => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App platform={platform} />
    </StrictMode>,
  )
})
